export default {"src":"/_next/static/media/panda-slateus.657029a6.svg","height":100,"width":100};